/**
 * DevExtreme (esm/ui/context_menu.js)
 * Version: 22.1.4
 * Build date: Fri Jul 22 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import ContextMenu from "./context_menu/ui.context_menu";
export default ContextMenu;
